import { enviroment } from "../../enviroment";
import { triggerBlobDownload } from "./blobDownload";

// The names/numbers template behind the "here" link of a LOGO line's "Upload
// spreadsheet" dialog (order create -> Add to order -> UPLOAD EXCEL FILE). The
// design dialog gets its template from the API (orders/download-template); the
// API has no template route for logo name lists, and its reader
// (OrderService.ReadNameQuantityRows) takes column A = name or number and
// column B = quantity from ROW 1 - there is no header row - and stops at the
// first empty A cell. So the template is a tiny .xlsx built once by
// scripts/make-logo-template-xlsx.py and embedded here as base64: sheet
// "Names" is empty (a wide text column A, a narrow integer column B), sheet
// "Instructions" explains the layout in English and Danish. When the layout
// changes, re-run `python3 -I scripts/make-logo-template-xlsx.py --ts`, paste
// its output below, open the new file in Excel and through ClosedXML (the
// API's reader) and then update the sha256 in
// logoTemplateDownload.templatePin.test.ts, which unpacks the result and pins
// it in the pull-request guard run.
export const LOGO_TEMPLATE_FILE_NAME = "kitmaker-names-numbers-template.xlsx";
export const LOGO_TEMPLATE_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const LOGO_TEMPLATE_XLSX_BASE64 = [
  "UEsDBBQAAAAIAAAAIQD28R5zEQEAADADAAATAAAAW0NvbnRlbnRfVHlwZXNdLnhtbMWSzU4DIRSF",
  "9z4FYdsU2i6MMTPThT9LdVEf4Ap3OmT4C5fW9u1lptWFqRqTJl0RuOec7wSoljtn2RYTmeBrPhcz",
  "ztCroI1f1/x19Ti94YwyeA02eKz5Hokvm6tqtY9IrJg91bzLOd5KSapDByRCRF8mbUgOctmmtYyg",
  "elijXMxm11IFn9HnaR4yeFPdYwsbm9nDrhwfiiS0xNndQTiwag4xWqMgl7ncev2NMj0SRHGOGupM",
  "pEkRcHmSMEx+Bhx9z+VmktHIXiDlJ3BFJXdWvofUv4XQi99DTrQMbWsU6qA2rlgExYSgqUPMzopx",
  "FQ6Mn/zNH8Ukx2V+5iJf+f/ssbhQD8p7i3Tu1xhDP8ly/PDNB1BLAwQUAAAACAAAACEABlnHgrEA",
  "AAAoAQAACwAAAF9yZWxzLy5yZWxzjc+xDoIwEAbg3adobpeCgzGGwmJMWA0+QG2PQoBe01aFt7ej",
  "GgfHy/33/bmyXuaJPdCHgayAIsuBoVWkB2sEXNvz9gAsRGm1nMiigBUD1NWmvOAkY7oJ/eACS4gN",
  "AvoY3ZHzoHqcZcjIoU2bjvwsYxq94U6qURrkuzzfc/9uQPVhskYL8I0ugLWrw39s6rpB4YnUfUYb",
  "f1R8JZIsvcEoYJn4k/x4IxqzhAKvSv7xYPUCUEsDBBQAAAAIAAAAIQDjZ5LL5gAAAIMBAAAPAAAA",
  "eGwvd29ya2Jvb2sueG1sjZDBbsMgDIbvewrk+0qawzRFgV6mSbns1O1OwWlQg4kwbbe3H0mVKcdd",
  "wMb+f3+mPXyHUdwwsY+kYL+rQCDZ6DydFXwe359fQXA25MwYCRX8IMNBP7X3mC6nGC+i6IkVDDlP",
  "jZRsBwyGd3FCKpU+pmBySdNZ8pTQOB4QcxhlXVUvMhhP8HBo0n88Yt97i2/RXgNSfpgkHE0u9Dz4",
  "iUG3M9WXxzvrP8g5FcZmf8OjOSmoQOpWbhoXqvUWZELZ9KOcXJafnzpX/gZEanwJUuf2s8G2uSPO",
  "6WoXjo2m3mjqZeg6Sa5s+hdQSwMEFAAAAAgAAAAhAOHHQinPAAAANQIAABoAAAB4bC9fcmVscy93",
  "b3JrYm9vay54bWwucmVsc72Rz2rDMAyH73sKo3ujJIUxRp1eSqHXkT6AcZQ/NLGNpXbN29dsLKxQ",
  "xg5jJ/GT0KcPtNlep1FdKPLgnYYiy0GRs74ZXKfhWO9XL6BYjGvM6B1pmIlhWz1t3mg0kna4HwKr",
  "BHGsoRcJr4hse5oMZz6QS5PWx8lIirHDYOzJdIRlnj9j/M6A6o6pDo2GeGgKUPUc6Dds37aDpZ23",
  "54mcPDiB7z6euCeSBDWxI9GwtBg/SpElKuBjmfKfZcqfZNZ/KcMyj+mzi8ln/jqPd9+ublBLAwQU",
  "AAAACAAAACEASvxq0n0BAAABBAAADQAAAHhsL3N0eWxlcy54bWy1k8tuwyAQRff9CsS+IY7Sqq1s",
  "Z1HJUjfZJJW6xTF2kGCwAEdxv76DH6ldVepL3ZiZC/cwMDjenLUiJ2GdNJDQaLGkRMDBFBKqhD7v",
  "s+s7SpznUHBlQCS0FY5u0qvY+VaJ3VEIT5AALqFH7+sHxtzhKDR3C1MLwJnSWM09prZirraCFy6Y",
  "tGKr5fKWaS6BpnFpwDtyMA34hK4GIY3dKzlxhWVFlKUxcC36/JErmVsZxJJrqdpeXgWB9db+m7M/",
  "QbrB4bxUal4eCmlcc++FhQwTMsT7tsZLAryqHtOt+2J1ZXkbrW4mhm7AfXNjC2zNuHNERymNlSg9",
  "GqysjmH0pmZh0nujMSgkrwxwFZCjYwgQexBK7UL/XsoZ+1wSaHSm/VORUHwI4fRjiAUNYY/pk8Cf",
  "0nr2BLv+FZacywt/5l7f/8hOeF2rdtvoXNise4jhoB+h0T8wJ8eMvsvMDIwsNlzjpFezTl1UEt5z",
  "QrehEDUB5o1UXsInXUIme/950zdQSwMEFAAAAAgAAAAhAOTmpdk6AQAANAIAABgAAAB4bC93b3Jr",
  "c2hlZXRzL3NoZWV0MS54bWyNUUtvwjAMvu9XRLmPlCLYhNpyQWg7TJr2PIfWbSOSuErMgH+/NAE0",
  "aTvsEvmz9T0cF6uj0ewLnFdoSz6dZJyBrbFRtiv5+9vm9p4zT9I2UqOFkp/A81V1UxzQ7XwPQCwI",
  "WF/ynmhYCuHrHoz0ExzAhkmLzkgK0HXCDw5kE0lGizzLFsJIZXlSWLr/aGDbqhrWWO8NWEoiDrSk",
  "EN/3avC8KqLDh4KD/1EzkttX0FATNGFPzsYFtoi7cfgYWhkXVSF+cTfR/NmxBlq51/SChwdQXU9B",
  "ZD5SatQ+vswoG5WNPCYH1VBf8tli/MGThtis957QfKbR9CyQqPmZml+p0+xKzf+iimQeg64lydAa",
  "ZAdP0nXKeqahDTGzyR1nLkWONeEQqzlnW6QgeUF9OA+4Ec04axHpAkar68Grb1BLAwQUAAAACAAA",
  "ACEAAzbnJnwCAADzBQAAGAAAAHhsL3dvcmtzaGVldHMvc2hlZXQyLnhtbI1U227bMAx931cQfmqB",
  "NXZ6WdMiTpGh6FZgK4a1655Vm7Y16+JJcpL+0L5h7/2xUXLiBhjs7cG2RFrnUOQh51cbKWCFxnKt",
  "0mg6SSJAlemcqzKNvj3cHM0isI6pnAmtMI2e0UZXizfztTa1rRAdEICyaVQ511zGsc0qlMxOdIOK",
  "PIU2kjnamjK2jUGWh0NSxMdJ8i6WjKuoQ7g0/4Ohi4JneK2zVqJyHYhBwRyFbyve2GgxDwyPHNd2",
  "bw0+4Ceta7+5zdMoieLFPP7r35tA9sVAjgVrhfuq1x+Rl5Wj5Jz5I5kWNrxBcp+xCCTbhO+a565K",
  "owtKYdZap+X3zjANTN25wHHNHFvMjV6D8V5C84slQVAeTyIgLq4EV3jvDHk5nXOLW2WdabNw0Xns",
  "CNHb44weQurhjnu44wGg+1C1KRzcMYn28BIoslYqWEIKikygDahWPqF5u3O9J9fPlinH3TMcMFhX",
  "WuD2p8PJSDQnfTRD17rTUJEq0IA/cuS1ZhxwBRkKAcvpGPppj346gP5QIQhuHWk6t8AcODIU3HiL",
  "bOgygcWzbXMwRnfW050NpZatEJiFyUbYDVDTQNsIzfIx1PMe9Xy0/o/4Q2CuqC9HwGY92GwAZmnq",
  "/drXmtpa4bb4KwWUDwz1l77+O7cXAJWfCTgg7VQoKJNMjJb+og/lYlDRJSrQfvjUhhfOmpdfdY2v",
  "IgjVwX+IYJq8NlAywPSJJEBUVrTO0e1WmEPx8ptUgEBtSpLviPhrOkYZ91p2OsD4ASVYLbdK0OWY",
  "EOK9odCwEj8zU3JlQWBB2MmEdGG6CRTWTjdhRSJ80o7i3+26PvI70lChtdtt/Pjp5/XiD1BLAQIU",
  "AxQAAAAIAAAAIQD28R5zEQEAADADAAATAAAAAAAAAAAAAACkgQAAAABbQ29udGVudF9UeXBlc10u",
  "eG1sUEsBAhQDFAAAAAgAAAAhAAZZx4KxAAAAKAEAAAsAAAAAAAAAAAAAAKSBQgEAAF9yZWxzLy5y",
  "ZWxzUEsBAhQDFAAAAAgAAAAhAONnksvmAAAAgwEAAA8AAAAAAAAAAAAAAKSBHAIAAHhsL3dvcmti",
  "b29rLnhtbFBLAQIUAxQAAAAIAAAAIQDhx0IpzwAAADUCAAAaAAAAAAAAAAAAAACkgS8DAAB4bC9f",
  "cmVscy93b3JrYm9vay54bWwucmVsc1BLAQIUAxQAAAAIAAAAIQBK/GrSfQEAAAEEAAANAAAAAAAA",
  "AAAAAACkgTYEAAB4bC9zdHlsZXMueG1sUEsBAhQDFAAAAAgAAAAhAOTmpdk6AQAANAIAABgAAAAA",
  "AAAAAAAAAKSB3gUAAHhsL3dvcmtzaGVldHMvc2hlZXQxLnhtbFBLAQIUAxQAAAAIAAAAIQADNucm",
  "fAIAAPMFAAAYAAAAAAAAAAAAAACkgU4HAAB4bC93b3Jrc2hlZXRzL3NoZWV0Mi54bWxQSwUGAAAA",
  "AAcABwDGAQAAAAoAAAAA",
].join("");

// window.atob yields a byte string; copy it into a typed array for the Blob.
export function decodeBase64ToBytes(base64: string): Uint8Array {
  const binary = window.atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

export function createLogoTemplateBlob(): Blob {
  return new Blob([decodeBase64ToBytes(LOGO_TEMPLATE_XLSX_BASE64)], {
    type: LOGO_TEMPLATE_MIME_TYPE,
  });
}

export function downloadLogoTemplate(): void {
  triggerBlobDownload(createLogoTemplateBlob(), LOGO_TEMPLATE_FILE_NAME);
}

// What the logo upload dialogs pass as onDownload. Flag off = undefined, so
// the dialog's prop stays unset and the "here" link stays inert.
export function logoTemplateDownloadHandler(): (() => void) | undefined {
  return enviroment.logoTemplateDownloadEnabled ? downloadLogoTemplate : undefined;
}
